var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"view-button-general",class:'type-' + _vm.type},[(_vm.href)?_c('a',{staticClass:"btn",attrs:{"href":_vm.href}},[_vm._t("default")],2):_c('button',{staticClass:"btn"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }